export const TAB_STATUS = {
    Pending: 'Pending',
    Open: 'Open',
    Closed: 'Closed',
} as const;

export type TabStatus = (typeof TAB_STATUS)[keyof typeof TAB_STATUS];
